export default __webpack_public_path__ + "static/media/generate.1b4dcf5c.svg";